import { defineMessages } from 'react-intl'

const composerVoiceMessages = defineMessages({
  microphoneLabel: {
    id: 'DGeX8NYE6Jsns_lEn7qT',
    defaultMessage: 'Speak your message',
    description: 'Accessibility label for the TripPlanner chat microphone button that records and transcribes a voice message',
  },
  microphoneUnavailable: {
    id: 'bjPFSB1jLB0ESumeo2Br',
    defaultMessage: 'We couldn’t access your microphone. Check your browser’s microphone permission.',
    description: 'Snackbar shown in TripPlanner chat when voice recording cannot start because the microphone is blocked or missing',
  },
  transcriptionFailed: {
    id: 'Ddkokhf5KG7PNw-66nSd',
    defaultMessage: 'We couldn’t transcribe that. Please try again.',
    description: 'Snackbar shown in TripPlanner chat when a voice recording could not be turned into text',
  },
})

export default composerVoiceMessages
